import { Col, Row, Select } from "antd";
import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import EndPoints from "../../../services/end-points";
import Form from "../../form-components/from";
import { IProduct } from "../../../models/product/response";
import { ICategory } from "../../../models/category/response";
import { INITIAL_PAGE } from "../../../utils/helpers/constants";
import TrademarkStatisticsContext from "../../../context/statistcs-trademark/context";
import AuthContext from "../../../context/auth/context";
import FormItem from "../../general/form-item";

const PartnerFilter: React.FC = () => {
  const { t } = useTranslation();

  const [products, setProducts] = useState<IProduct[]>([]);
  const [loadingProducts, setLoadingProducts] = useState(true);
  const [categories, setCategories] = useState<ICategory[]>([]);
  const [loadingCategories, setLoadingCategories] = useState(true);
  const { userDetails: user } = useContext(AuthContext);
  const { query, actions } = useContext(TrademarkStatisticsContext);

  const [selectedCategory, setSelectedCategory] = useState<number | null>(null);
  const [selectedProducts, setSelectedProducts] = useState<number[]>([]);

  useEffect(() => {
    const getProducts = async () => {
      try {
        const { data } = await EndPoints.product.getAllProducts({
          perPage: -1,
          filters: [{ name: "trademarkId", value: user?.trademark?.id, operation: "eq" }]
        });
        setProducts(data.data);
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoadingProducts(false);
      }
    };

    const getCategories = async () => {
      try {
        const { data } = await EndPoints.category.getAllCategories({
          light: true,
          perPage: -1,
          filters: [{ name: "hasProductsWithTrademark", value: user?.trademark?.id, operation: "eq" }]
        });
        setCategories(data.data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoadingCategories(false);
      }
    };

    getProducts();
    getCategories();
  }, []);

  useEffect(() => {
    if (selectedCategory !== null) {
      setSelectedProducts([]); 
    }
  }, [selectedCategory]);

  useEffect(() => {
    if (selectedProducts.length > 0) {
      setSelectedCategory(null); 
    }
  }, [selectedProducts]);

  return (
    <Form
      formId="partner-filter"
      onSubmit={() => {
        const filter: any = {
          page: INITIAL_PAGE,
          perPage: query?.perPage,
          filters: [
            selectedCategory ? { name: "categoryId", value: selectedCategory, operation: "eq" } : undefined,
            selectedProducts.length > 0 ? { name: "productIds", value: selectedProducts, operation: "in" } : undefined, 
          ].filter(Boolean),
        };
      
        actions.setQuery(filter);
      }}
      
    >
      <Row justify={"start"} gutter={[10, 0]}>
        {/* اختيار المنتجات */}

        <Col span={8}>
        <FormItem label={t("products")}>
          <Select
            style={{ width: "100%" }}
            disabled={!!selectedCategory} // استخدام `!!` لضمان تحويل القيمة إلى boolean
            mode="multiple"
            allowClear
            loading={loadingProducts}
            value={selectedProducts}
            onChange={(value: number[]) => setSelectedProducts(value)}
            onClear={() => {
              setSelectedCategory(null); // عند مسح المنتجات، يتم تفعيل التصنيف
            }}
            placeholder={t("select_products")}
            options={products.map((product) => ({
              label: product?.name as string,
              value: product?.id as number,
            }))}
          />
        </FormItem>
      </Col>

      {/* اختيار التصنيف */}
      <Col span={8}>
        <FormItem label={t("category")}>
          <Select
            style={{ width: "100%" }}
            disabled={selectedProducts.length > 0}
            allowClear
            loading={loadingCategories}
            value={selectedCategory}
            onChange={(value: number) => {
              setSelectedCategory(value);
              setSelectedProducts([]); // مسح المنتجات عند اختيار تصنيف جديد
            }}
            onClear={() => {
              setSelectedCategory(null);
              setSelectedProducts([]); // مسح المنتجات عند مسح التصنيف
            }}
            placeholder={t("select_category")}
            options={categories.map((category) => ({
              label: category.name,
              value: category.id,
            }))}
          />
        </FormItem>
      </Col>

      </Row>
    </Form>
  );
};

export default PartnerFilter;
